import * as moment from 'pkp-moment-timezone-all-years';
import * as angular from 'angular';
import { config } from 'angular/utils/config';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name activity
     * @memberof app
     *
     * @restrict E
     * @scope {}
     *
     * @description
     * Actually multiple activities that need to be mapped before they can be applied to this directive.
     * Map the activities coming from the backend using {@link app.activitiesService#map}.
     *
     * @param {*} activities
     * @param {*} filterStates
     * @param {*} filterAuctionId
     * @param {*} auctionIds
     * @param {*} sortBy
     * @param {*} actions:
     * @param {*} deleteBid
     * @param {*} onStaBidSuccess
     *
     * @author bjnowak.btc
     */
    angular.module('app').directive('activity', activity);

    function activity(activitiesService, auctionsOverviewService) {
        return {
            restrict: 'E',
            scope: {
                activities: '=',
                filterStates: '@',
                sortBy: '@',
                actions: '=?',
                deleteBid: '&',
                deleteStorageBid: '&',
                onStaBidSuccess: '&?'
            },
            template: require('app/_directives/activity.directive.html'),
            controller: Controller,
            controllerAs: 'activityCtrl',
            link: linkFn
        };

        function linkFn(scope) {
            scope.actions = scope.actions !== true ? false : scope.actions;
        }

        function Controller($rootScope, $scope) {
            var vm = this;

            $scope.DATES = activitiesService.DATES;
            $scope.CATEGORY = activitiesService.CATEGORY;
            $scope.PERIOD_TYPE = activitiesService.PERIOD_TYPE;
            $scope.STATE = activitiesService.STATE;
            $scope.TRANSACTION_TYPE = activitiesService.TRANSACTION_TYPE;
            $scope.appBaseUrl = config.appBaseUrl;
            $scope.isDefinedButEmpty = isDefinedButEmpty;
            $scope.denyActivityEdit = denyActivityEdit;
            $scope.uiPlaceSTABidSuccess = 'activity-sta-bid-placed';
            $scope.onSTABidSuccessInActivity = onSTABidSuccessInActivity;
            $scope.onClose = onClose;
            $scope.permitLongTermBidDeletion = permitLongTermBidDeletion;
            $scope.getProductNameForPeriodType = getProductNameForPeriodType;
            $scope.performDeleteBid = performDeleteBid;
            $scope.performDeleteStorageBid = performDeleteStorageBid;
            $scope.createAnotherComfortBid = function createAnotherComfortBid(
                networkPointId
            ) {
                return (
                    config.appBaseUrl +
                    '/transport/auctions/comfort-bids/create?networkPointId=' +
                    networkPointId
                );
            };

            $scope.getEditComfortBidUrl = function getEditComfortBidUrl(
                comfortBidId
            ) {
                return (
                    config.appBaseUrl +
                    '/transport/auctions/comfort-bids/edit/' +
                    comfortBidId
                );
            };

            /**
             * @memberof activity
             * @param allocation
             * @returns {boolean|*}
             */
            function isDefinedButEmpty(allocation) {
                return (
                    angular.isDefined(allocation) &&
                    angular.equals(allocation, {})
                );
            }

            function getProductNameForPeriodType(periodType) {
                return auctionsOverviewService.getPeriodNameByType(periodType);
            }

            function performDeleteBid(data, activity) {
                $scope.deleteBid(data);
            }

            function performDeleteStorageBid(data, activity) {
                $scope.deleteStorageBid(data);
            }

            /**
             * @memberof activity
             */
            function onSTABidSuccessInActivity() {
                if (!!$scope.onStaBidSuccess) {
                    $scope.onStaBidSuccess(); //call success of parent scope to show e.g. success message in parent scope
                } else {
                    $rootScope.$broadcast($scope.uiPlaceSTABidSuccess);
                }
            }

            /**
             * @memberof activity
             * @param index
             */
            function onClose(index) {
                vm.uiShowShortTermBidForm[index] = false;
                vm.uiSubmitAnotherBid[index] = false;
            }

            /**
             * @memberof activity
             * @see {@link app.auctionsOverviewService#permitLongTermBidDeletion}
             * @param round
             * @param state
             * @returns {boolean}
             */
            function permitLongTermBidDeletion(round, state) {
                return auctionsOverviewService.permitLongTermBidDeletion(
                    round,
                    state
                );
            }

            function denyActivityEdit(activity: ActivityDto): boolean {
                // deny edit when submission interval is already expired for comfort bids
                return (
                    activity.category ===
                        activitiesService.CATEGORY.COMFORT_BID &&
                    moment().isAfter(activity.runtime.end)
                );
            }
        }
    }
})();
